/** Calculate the number of pages */
export function getPageCount(itemsCount: number, pageSize: number): number {
    if (itemsCount && pageSize) {
        return Math.ceil(itemsCount / pageSize);
    }
    return 0;
}
